var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmiletrainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 47,
    viewBox: "0 0 107 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1856_12992)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106.154,
    height: 46,
    transform: "translate(0 0.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18652 46.4042C9.27548 46.4932 9.40895 46.4932 9.45339 46.4042L18.572 37.2857C18.661 37.1967 18.661 37.0632 18.572 37.0187L9.49791 27.8557C9.40895 27.7667 9.27548 27.7667 9.23097 27.8557L9.18652 46.4042Z",
    fill: "#6DA9DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36352 20.2037L6.87255 20.3371L3.66992 10.4179H9.36352V20.2037Z",
    fill: "#4B79BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31836 20.2037L11.8093 20.3371L15.0119 10.4179H9.31836V20.2037Z",
    fill: "#6DA9DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3168 46.4483C9.27235 46.4928 9.22784 46.4483 9.1834 46.4038L0.0647683 37.2852C-0.0241936 37.1963 -0.0241936 37.0628 0.0647683 37.0183L9.1834 27.8997C9.27235 27.8108 9.27235 27.8108 9.36131 27.8997L9.3168 46.4483Z",
    fill: "#4B79BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8721 0.498901C8.33667 0.498901 6.29058 2.50055 6.24609 4.99148H15.5426C15.4536 2.50055 13.4076 0.498901 10.8721 0.498901Z",
    fill: "#BFBCBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6578 1.34369C14.6117 1.34369 12.9659 2.98948 12.877 4.99113H20.3942C20.3498 2.98948 18.7039 1.34369 16.6578 1.34369Z",
    fill: "#BFBCBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9961 2.72363C20.7062 2.72363 19.6831 3.74669 19.6387 4.99216H24.3092C24.3092 3.74669 23.2416 2.72363 21.9961 2.72363Z",
    fill: "#BFBCBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4643 3.34647C26.5302 3.34647 25.774 4.10264 25.7295 5.03674H29.199C29.1545 4.05816 28.3983 3.34647 27.4643 3.34647Z",
    fill: "#BFBCBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0126 10.4181C12.833 10.4181 6.16086 10.4181 3.66992 10.4181C3.66992 8.14958 5.09331 6.28137 6.87255 6.28137H11.8545C13.5891 6.28137 15.0126 8.14958 15.0126 10.4181Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31836 35.7285C14.3002 35.684 18.348 31.5918 18.348 26.5654C18.348 21.5391 14.3002 17.4468 9.31836 17.4023V35.7285Z",
    fill: "#F37654"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31574 35.7285C4.3339 35.684 0.286133 31.5918 0.286133 26.5654C0.286133 21.5391 4.3339 17.4468 9.31574 17.4023V35.7285Z",
    fill: "#EE3124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18365 31.9919C7.84923 31.9919 6.47034 31.6361 5.26935 30.8354C4.60214 30.3906 3.9794 29.8568 3.53459 29.1896C3.35667 28.9228 3.40115 28.6114 3.62355 28.3889C3.89044 28.211 4.2018 28.2555 4.42421 28.478C4.82454 29.0117 5.31383 29.4565 5.89208 29.8568C8.64991 31.6806 12.3863 30.8799 14.21 28.1221C14.388 27.8552 14.7438 27.8108 14.9662 27.9442C15.2331 28.1221 15.2776 28.478 15.1441 28.7003C13.7652 30.8354 11.4967 31.9919 9.18365 31.9919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9268 23.4957C42.6813 23.4957 41.5248 23.985 40.7686 25.3194C40.2349 23.9405 39.0338 23.4512 37.8773 23.4512C36.8988 23.4512 35.8313 23.807 35.2974 24.8301L35.164 23.5846H33.3848V32.8367H35.2974V27.7658C35.2974 26.387 36.1426 25.2305 37.5215 25.2305C38.9004 25.2305 39.6566 26.387 39.7011 27.7214V32.7922H41.6583V27.7214C41.6583 26.3424 42.5479 25.2305 43.9268 25.2305C45.3057 25.2305 45.9729 26.2979 45.9729 27.6769V32.7922H47.93V27.6769C47.8411 25.1415 46.5067 23.4957 43.9268 23.4957Z",
    fill: "#EE3124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8883 23.6287H49.9756V32.9252H51.8883V23.6287Z",
    fill: "#EE3124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.748 20.9598C49.748 22.5611 52.15 22.5611 52.15 20.9598C52.15 19.3584 49.748 19.3584 49.748 20.9598Z",
    fill: "#EE3124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9303 19.8029H54.0176V32.9247H55.9303V19.8029Z",
    fill: "#EE3124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1922 19.8029H66.6504V20.6925H71.4096V32.9247H72.4329V20.6925H77.1922V19.8029Z",
    fill: "#6DA9DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8424 25.2755L76.7978 23.6297H75.9521V32.8817H76.8863V27.4995C76.8863 25.8092 78.221 24.4303 79.9556 24.3859C80.4899 24.3859 81.0235 24.5193 81.5125 24.8307L81.913 24.0745C81.2903 23.7187 80.6229 23.4962 79.911 23.5407C78.71 23.5407 77.4206 24.03 76.8424 25.2755Z",
    fill: "#6DA9DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5398 25.6752C89.784 24.2518 88.2716 23.5401 86.7593 23.5401C84.1791 23.5401 82.0439 25.4528 82.0439 28.2995C82.0439 31.1464 84.1791 33.0591 86.7593 33.1035C88.2716 33.1035 89.6502 32.4363 90.5398 30.9684V32.9256H91.4739C91.4739 29.812 91.4739 26.7428 91.4739 23.6736H90.5398V25.6752ZM86.7593 32.1694C84.6688 32.1694 82.9781 30.6126 82.9781 28.2995C82.9781 25.9865 84.6688 24.4297 86.7593 24.4297C91.9191 24.3852 91.9191 32.1694 86.7593 32.1694Z",
    fill: "#6DA9DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.076 23.585H94.1426V32.8815H95.076V23.585Z",
    fill: "#6DA9DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.873 20.6041C93.873 21.5827 95.3415 21.5827 95.3415 20.6041C95.3415 19.6256 93.873 19.6256 93.873 20.6041Z",
    fill: "#6DA9DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.93 23.4512C100.64 23.4512 99.3498 23.985 98.6386 25.2749V23.6291H97.749V32.8812H98.6832V27.7214C98.6832 25.8087 100.017 24.3853 101.93 24.3408C103.931 24.3408 105.222 25.4528 105.222 27.5434V32.8812H106.156V27.5434C106.111 24.9635 104.377 23.4512 101.93 23.4512Z",
    fill: "#6DA9DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.806 28.7451C65.7171 29.6347 64.8719 30.4353 64.0713 30.8801C62.5589 31.6808 61.1355 31.4139 60.2904 30.2574L67.2294 26.5655C66.6957 25.1421 65.5392 24.0301 64.0713 23.5408C63.6265 23.4073 63.1372 23.3184 62.6034 23.3184C62.1141 23.3184 61.6248 23.4073 61.1355 23.5408C60.8242 23.6297 60.5128 23.7632 60.2015 23.9411C58.6891 24.7863 57.666 26.3876 57.666 28.2558C57.666 30.9692 59.8456 33.1487 62.5589 33.1931H62.6034C64.4271 33.1931 66.0285 32.2146 66.8736 30.7022C67.2294 30.124 67.4518 29.4567 67.4963 28.7451H65.806ZM61.0466 25.4535C62.4255 24.7418 63.8488 24.9197 64.8274 25.9873L59.5342 28.7895C59.1784 27.5441 59.8011 26.1207 61.0466 25.4535Z",
    fill: "#EE3124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2873 25.0971C25.8639 24.8747 24.6629 24.5189 24.6629 23.2289C24.6629 21.9834 25.7305 21.2273 27.1539 21.2273C28.2659 21.2273 29.3334 21.8055 29.8227 22.6952L31.1572 21.6276C30.2231 19.8483 28.6662 19.4035 27.1094 19.4035C25.1522 19.4035 22.8837 20.4711 22.9282 23.1844C22.9282 25.9867 24.9743 26.6539 27.1539 27.0098C28.6662 27.2322 29.9117 27.7215 29.9117 29.1448C29.9117 30.7907 28.4883 31.3245 27.1539 31.3245C25.9084 31.3245 24.5295 30.7462 23.7733 29.1894L22.4834 30.2569C23.4619 32.4809 25.0633 33.2371 27.1539 33.2371C29.4224 33.2371 31.6465 32.1251 31.6465 29.1894C31.6465 26.2091 29.5113 25.453 27.2873 25.0971Z",
    fill: "#EE3124"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1856_12992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106.154,
    height: 46,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiletrainLogo);
export default __webpack_public_path__ + "static/media/smiletrain-logo.aabb7a49041e94b991f63a83ae64105f.svg";
export { ForwardRef as ReactComponent };